import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { DefaultToolbar } from "colbi_web_ui/lib/components";
import { SovosToolbarActions, SovosToolbarGroup, SovosIconButton } from "mosaic-react";
import FindingModalButton from "../FindingButtons/FindingModalButton";
import { Refresh } from "mosaic-react-icons";

const RulesToolbar = ({ toolbarProps, defaultToolbarProps }) => {
    const { i18n, reload } = useGlobalValue();
    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup sx={{ flex: "1 1 auto" }}>
                <SovosToolbarActions>
                    <FindingModalButton {...toolbarProps} />
                    <DefaultToolbar {...defaultToolbarProps} />
                    <SovosIconButton
                        tooltipText={i18n`Reload`}
                        position="end"
                        onClick={() => {
                            reload && reload();
                        }}
                        children={<Refresh />}
                    />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default RulesToolbar;
